























export default {
  name: 'GenericModal',
  props: {
    'header-text': {},
    'body-text': {},
    'success-button-text': {},
    'cancel-button-text': {},
    'max-width': {type: String, default: "350px" },
    'disabled': {required: false, default: false}
  },
  data () {
    return {
      dynamicModalContainer: {'max-width': (this as any).maxWidth}
    }
  },
  created: function () {
    (this as any).dynamicModalContainer = {'max-width': (this as any).maxWidth };
  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsReusable/genericModal.vue